import { useEffect, useState } from 'react';

export const useEmbeddedMode = () => {
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const embedded = params.get('embedded') === 'true';
    setIsEmbedded(embedded);

    if (embedded) {
      document.documentElement.setAttribute('data-embedded', 'true');
      document.body.classList.add('embedded-mode');
    }
  }, []);

  return isEmbedded;
};
